export default function AppDownloadBanner() {
  return (
    <section id="baixar-app" className="py-20 bg-orange-500 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-white -translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Text */}
          <div className="text-center lg:text-left max-w-xl">
            <span className="bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-widest">
              App Gratuito
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-4 mb-4">
              Baixe o app e alugue<br />sem entrada
            </h2>
            <p className="text-white/80 text-base mb-8 leading-relaxed">
              Cadastre-se gratuitamente, escolha seu veículo e pague a fatura direto pelo app.
              Sem burocracia, sem entrada, 100% digital em Campinas e região.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="#"
                className="flex items-center gap-3 bg-black text-white px-6 py-3.5 rounded-xl hover:bg-gray-900 transition-all cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-apple-fill text-xl"></i>
                </div>
                <div>
                  <div className="text-xs text-white/70">Disponível na</div>
                  <div className="text-sm font-bold">App Store</div>
                </div>
              </a>
              <a
                href="#"
                className="flex items-center gap-3 bg-black text-white px-6 py-3.5 rounded-xl hover:bg-gray-900 transition-all cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-google-play-fill text-xl"></i>
                </div>
                <div>
                  <div className="text-xs text-white/70">Disponível no</div>
                  <div className="text-sm font-bold">Google Play</div>
                </div>
              </a>
            </div>
          </div>

          {/* Phone mockup */}
          <div className="relative flex-shrink-0">
            <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-white/10 flex items-center justify-center">
              <div className="w-48 h-48 md:w-60 md:h-60 rounded-full bg-white/20 flex items-center justify-center">
                <div className="w-24 h-24 flex items-center justify-center">
                  <i className="ri-smartphone-line text-white text-8xl opacity-80"></i>
                </div>
              </div>
            </div>
            {/* Floating badges */}
            <div className="absolute top-4 -left-8 bg-white rounded-xl px-4 py-2 shadow-lg">
              <div className="text-xs text-gray-500">Cadastro</div>
              <div className="text-sm font-bold text-gray-900">100% Gratuito</div>
            </div>
            <div className="absolute bottom-8 -right-8 bg-white rounded-xl px-4 py-2 shadow-lg">
              <div className="text-xs text-gray-500">Sem entrada</div>
              <div className="text-sm font-bold text-green-600">Aprovação rápida</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
